import React, { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'

interface ICustomSwitchProps {
  value: boolean
  setValue: Dispatch<SetStateAction<boolean>> | ((value: boolean) => void)
  enabledColor?: string
  disabledColor?: string
  defaultOpacity?: number
  unhoverGrayscale?: boolean
  disabled?: boolean
}

export const CustomSwitch: React.FC<ICustomSwitchProps> = ({
  value,
  setValue,
  enabledColor,
  disabledColor,
  defaultOpacity,
  unhoverGrayscale,
  disabled,
}) => {
  return (
    <InputLabel
      onClick={e => e.stopPropagation()}
      onChange={e => e.stopPropagation()}
      enabledColor={enabledColor}
      defaultOpacity={defaultOpacity}
      unhoverGrayscale={unhoverGrayscale}
      enabled={value}
    >
      <input
        type="checkbox"
        disabled={disabled || false}
        checked={value}
        onChange={e => {
          setValue(e.target.checked)
        }}
      />
      <DotSpan disabledColor={disabledColor} />
    </InputLabel>
  )
}

export const DotSpan = styled.span<{ disabledColor?: string }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme, disabledColor }) => (disabledColor ? theme.getColorByName(disabledColor) : theme.red)};
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 7px;

  &:before {
    position: absolute;
    content: '';
    height: 10px;
    width: 10px;
    left: 1px;
    bottom: 1px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`
export const InputLabel = styled.label<{
  enabledColor?: string
  defaultOpacity?: number
  enabled: boolean
  unhoverGrayscale?: boolean
}>`
  position: relative;
  display: inline-block;
  width: 22px;
  height: 12px;
  margin-left: 4px;
  margin-bottom: 0px;
  filter: grayscale(${({ unhoverGrayscale }) => (unhoverGrayscale ? 1 : 0)});
  opacity: ${({ defaultOpacity, enabled }) => (enabled ? 1 : defaultOpacity || 1)};
  &:hover {
    opacity: 1;
  }
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + ${DotSpan} {
    background-color: ${({ theme, enabledColor }) => (enabledColor ? theme.getColorByName(enabledColor) : theme.green)};
  }

  input:focus + ${DotSpan} {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + ${DotSpan}:before {
    -ms-transform: translateX(10px);
    transform: translateX(10px);
  }
  input:disabled + ${DotSpan} {
    background: ${({ theme }) => theme.white11};
  }
  input:disabled + ${DotSpan}:before {
    background: ${({ theme }) => theme.white11};
  }
`
